"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlackTextLink = exports.GrayText = exports.OfferTitle = exports.FullWidthCentredDiv = exports.StyledInput = void 0;
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledInput = (0, styled_components_1.default)(elements_1.Input) `
	width: 30%;
`;
exports.FullWidthCentredDiv = styled_components_1.default.div `
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;
exports.OfferTitle = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.black};
	width: 150px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`;
exports.GrayText = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gray5};
`;
exports.BlackTextLink = styled_components_1.default.a `
	&& {
		color: rgba(0, 0, 0, 0.85);
		&:hover {
			color: #4a1c56;
		}
	}
`;
